export interface AppConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  apiUrl: string;
  stage: string;
  mspName: string;
}

/** Demo mode runs the whole UI against in-memory data, without AWS. */
export const DEMO_MODE =
  import.meta.env.VITE_DEMO_MODE === '1' || import.meta.env.VITE_DEMO_MODE === 'true';

export const DEMO_CONFIG: AppConfig = {
  region: 'ap-southeast-2',
  userPoolId: 'demo',
  userPoolClientId: 'demo',
  apiUrl: 'demo://api',
  stage: 'demo',
  mspName: 'Pro Advance IT',
};

/**
 * The deployed SPA reads /config.json, which CDK writes next to the bundle at
 * deploy time (pool ids, API URL). Locally, copy public/config.example.json.
 */
export async function loadConfig(): Promise<AppConfig> {
  if (DEMO_MODE) return DEMO_CONFIG;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(
      'config.json not found. Deploy with CDK, or copy public/config.example.json to public/config.json for local development.',
    );
  }
  const cfg = (await res.json()) as Partial<AppConfig>;
  for (const key of ['region', 'userPoolId', 'userPoolClientId', 'apiUrl'] as const) {
    if (!cfg[key]) throw new Error(`config.json is missing "${key}"`);
  }
  return { stage: 'dev', mspName: 'IoT Dashboard', ...cfg } as AppConfig;
}
